<template>
    <v-sheet width="100%" height="100%" style="align-content: center; text-align: center;" color="transparent" v-if="FINAL_DATA_VALUES.length === 0" >
        <Prog_circular/>
    </v-sheet>

    <v-sheet class="pa-4" color="transparent" v-for="(item,i) in FINAL_DATA_VALUES" :key="i">
        <h1 class="ml-4">{{ item.name }}</h1>
            <v-sheet class="text-center defaultCard " color="bgtopology">
                <EasyDataTable
                v-if="item.info.length > 0"
                show-index
                table-class-name="customize-table"
                :headers="HEADER_RAJANT"
                :items="item.info"
                :rows-per-page="2"
                :hide-footer="true"
                class="ma-4"
                @click-row="showDialog"
                >         
                <template #item-status ="item">
                    <v-sheet width="100%" height="20" :color="getCardColor(item.status)"/>                       
                </template>
                </EasyDataTable>
                <Prog_circular v-else/>
            </v-sheet>
            
    </v-sheet>

     <!-- DIALOG COMPONENT -->
        <v-dialog v-model="dialog" width="85%">
            <DialogComponent
            v-if="dialog"
            :ip="selectedIp"
            :typeSel="selectedType"
            :name="selectedName"
            @dialog="closeDialog"
            :status="'Ok'"
            />             
        </v-dialog>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';

/********************************
 ********** COMPONENTES *********
 *******************************/
import Prog_circular from '@/components/PrincipalComponents/Prog_circular.vue';
import DialogComponent from '@/components/SmartLink/dialog/dialogComponent.vue';


/********************************
 ********** CONSTANTES **********
 *******************************/
import { getFinalStatusByStatitics, getStatusByLatency, /*getStatusByRXLVL, getStatusBySNR*/ } from '@/functions/maps';
import { LABELS } from '@/constants/labels';

/********************************
 *********** SERVICES ***********
 *******************************/
import { getAllLatencyLast, /*getLastRXLVLandSNR,*/ getRajantLastGPS } from '@/services/Smartlink/Map';
import { getAllCostLastMinute, getAllTempAndVoltageLastMinute } from '@/services/Smartlink/KPI';
import { getAllInventoryData } from '@/services/Smartlink/Admin';

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
const { t } = useI18n()

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
import { getOperabilityLastDayTopology } from '@/services/Smartlink/Topology';
import { getBandWidthData } from '@/services/RAOS/Status';
const store = useStore();

const HEADER_RAJANT = computed(() =>  [
    { text: 'IP', value: "ip", sortable: true },
    { text: t('labels.lastConnection'), value: "lastconection", sortable: true },
    { text: t('labels.status'),  value: "status", sortable: true },
    { text: `${t('labels.latency')} (ms)`, value: "latencia", sortable: true },
    { text: `${t('labels.temperature')} (°C)`, value: "temperatura", sortable: true },
    { text: `${t('labels.voltage')} (Volt)`, value: "voltaje", sortable: true },
    { text: 'Througtput (Mbps)', value: "througtput", sortable: true },
    { text: `${t('labels.loss')} (%)`, value: "perdida", sortable: true },
    { text: `${t('labels.uptime')} (%)`, value: "uptime", sortable: true },
    { text: 'GPS', value: "gps", sortable: true },
])


const STATUS_COLOR:any = {
    OK : 'green',
    ALERT: 'yellow',
    ALARM: 'red',
    DOWN: 'grey'
}

function getCardColor (status:string){

    return STATUS_COLOR[status]
}

const allFinalStatiticsItems:any = ref({})

const allFinalStatusItems:any = ref({})



async function getAllFinalLatency(){
    const allData = await getAllLatencyLast()

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        const finalData = allData.data;
        finalData.forEach((item:any) => {
            if(!allFinalStatiticsItems.value[item.ip]) {
                allFinalStatiticsItems.value[item.ip] = {}
            }
            allFinalStatiticsItems.value[item.ip].latencia = getStatusByLatency(item.latencia)
            allFinalStatiticsItems.value[item.ip].latenciaValue = item.latencia
            allFinalStatiticsItems.value[item.ip].fecha = item.fecha
        })
         // 1. Esperamos a que TODAS estas consultas terminen en paralelo
        await Promise.all([
            getBandWidth(),
            getAllTemperatureAndVoltageLastMinute(),
            getAllItemsCostLastMinute(),
            getAllRajantLastGPS(),
            getOperabilityLastDay()
        ]);

        // 2. Esperamos a que esta se procese
        allFinalStatusItems.value = await getFinalStatusByStatitics(allFinalStatiticsItems.value);
        
        // 3. Ahora sí, llamamos a la función final con total seguridad
        // (Añade 'await' si esta función también hace peticiones HTTP)
        getAllInfoInventoryData();

    }
}

async function getBandWidth(){
    const allData = await getBandWidthData()

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){ 
        allData.data.forEach((item:any) => {
            if(allFinalStatiticsItems.value[item.ip]){
                const finalBandWidth = JSON.parse(item.bandwidth??'{ Tx : -1, Rx : -1 }')
                allFinalStatiticsItems.value[item.ip].througtput = finalBandWidth.Rx;
            }
        })
    }
}

async function getAllItemsCostLastMinute(){
    const allData = await getAllCostLastMinute()

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        const finalData = allData.data;
        finalData.forEach((item:any) => {
            if(allFinalStatiticsItems.value[item.ip]){
                allFinalStatiticsItems.value[item.ip].costo = item.costo
            }
        })
    }
}

async function getAllTemperatureAndVoltageLastMinute(){
    const allData = await getAllTempAndVoltageLastMinute()

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        const finalData = allData.data;
        finalData.forEach((item:any) => {
            if(allFinalStatiticsItems.value[item.ip]){
                allFinalStatiticsItems.value[item.ip].temperatura = item.temperatura
                allFinalStatiticsItems.value[item.ip].voltaje = item.voltaje
            }
        })
    }
}

async function getAllRajantLastGPS(){
    const allData = await getRajantLastGPS()

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        const finalData = allData.data;
        finalData.forEach((item:any) => {
            if(allFinalStatiticsItems.value[item.ip]){
                allFinalStatiticsItems.value[item.ip].gps = item.gps
            }
        })
    }
}

async function getOperabilityLastDay(){
    const allData = await getOperabilityLastDayTopology()

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        const finalData = allData.data;
        finalData.forEach((item:any) => {

            if(allFinalStatiticsItems.value[item.ip]){
                const totalUptime = item.ok + item.alert + item.alarm + item.down;
                const uptime = `${(((item.ok + item.alert + item.alarm) / totalUptime)*100).toFixed(2)}`;

                const NotDown = item.ok + item.alert + item.alarm ;
                const perdida = `${((item.down / NotDown)*100).toFixed(2)}`

                allFinalStatiticsItems.value[item.ip].uptime = uptime
                allFinalStatiticsItems.value[item.ip].perdida = perdida === 'Infinity' ? 100 : perdida
            }
        })
    }
}

const FINAL_DATA_VALUES = ref<any>([])

async function getAllInfoInventoryData(){
    const allData = await getAllInventoryData()

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        allData.data.forEach((item:any) => {
            if(item.tipo.toUpperCase() === 'PERFORADORA') {
                const finalItemInventory = {
                    tipo: item.tipo,
                    name: item.tag,
                    ip: item.ip,
                    lastconection: allFinalStatusItems.value[item.ip].fecha,
                    status: allFinalStatusItems.value[item.ip].status,
                    latencia: allFinalStatusItems.value[item.ip].latencia,
                    snrv: allFinalStatusItems.value[item.ip].snrv,
                    snrh: allFinalStatusItems.value[item.ip].snrh,
                    rxlvl: allFinalStatusItems.value[item.ip].rxlvl,
                    txlvl: allFinalStatusItems.value[item.ip].txlvl,
                    througtput: allFinalStatusItems.value[item.ip].througtput,
                    temperatura: allFinalStatusItems.value[item.ip].temperatura,
                    voltaje: allFinalStatusItems.value[item.ip].voltaje,
                    uptime: allFinalStatusItems.value[item.ip].uptime,
                    perdida: allFinalStatusItems.value[item.ip].perdida,
                    gps: allFinalStatusItems.value[item.ip].gps,
                    costo: allFinalStatusItems.value[item.ip].costo,
                }

                FINAL_DATA_VALUES.value.push({
                    name: item.tag,
                    info: [ finalItemInventory ]
                })
            }
        })

    }
}





/**
 * Mostrar el Dialogo
 */
 const dialog        = ref(false);

/**
 * IP del equipo Seleccionado de la tabla para mostrar en el DIÁLOGO
 */
const selectedIp    = ref('');

/**
 * Nombre del equipo Seleccionado de la tabla para mostrar en el DIÁLOGO
 */
const selectedName  = ref('');

/**
 * Tipo del equipo Seleccionado de la tabla para mostrar en el DIÁLOGO
 */
const selectedType  = ref('');

/**
 * Captura toda la información del elemento seleccionado en la tabla
 * y se almacenan los valores de (ip, tipo, nombre, marca, estado) en las variables correspondientes
 * para luego abrir el dialog con la información gráfica y estadística del equipo en cuestión
 * @param item La fila seleccionada en la tabla
 */
const showDialog    = (item:any) => {
    selectedIp.value    = item.ip??''; 
    selectedType.value  = item.tipo??'';
    selectedName.value  = item.name??'';
    dialog.value        = true;
}

/**
 * Cierra el Diálogo mediante un EMIT del componente de Dialogo
 * @param value valor FALSO
 */
const closeDialog = (value:boolean) => {
    dialog.value = value;
}


onMounted(async() => {
    await getAllFinalLatency();
})

</script>